export default __webpack_public_path__ + "422dbbf9dfa4623bd5145fbe82fc4c4f.svg";